import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-e8f9c8aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1/3 bg-red-100 flex items-center justify-center login-bar relative overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-3/5"
  })
], -1))
const _hoisted_3 = { class: "w-full h-2/3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleSwitcher = _resolveComponent("LocaleSwitcher")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LocaleSwitcher, { class: "absolute end-4 top-4 z-50" }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ])
  ]))
}